import { apiMockSwitcher } from 'APIPackage/MainModule/mock/apiMockSwitcher';

import { IMandatoryCategory } from '../interfaces/IMandatoryCategory';
import { getServiceBaseURL } from '../../MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from '../../MainModule/enums/APIServiceEnum';
import { handleResponse } from '../../MainModule/common/handleResponse';

export async function fetchMandatoryCategories(): Promise<IMandatoryCategory[]> {
  const url = `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/requirements-violation-categories`;
  const mockData = apiMockSwitcher<IMandatoryCategory[]>(url, 'GET');

  if (mockData) return mockData;

  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(handleResponse);
}
